import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PermissionGuard } from "../components/PermissionGuard";
import Spinner from "../components/Spinners";
import AutoLogin from "./auth/auto-login/AutoLogin";
import ForgotPassword from "./auth/forgot-password/ForgotPassword";
import Login from "./auth/login/Login";
import Register from "./auth/register/Register";
import ResetPassword from "./auth/reset-password/ResetPassword";
import { Main } from "./main";

const AIReasoningPage = lazy(() => import("./ai-reasoning/AIReasoningPage").then((m) => ({ default: m.AIReasoningPage })));
const BookingEngine = lazy(() => import("./booking-engine/BookingEngine").then((m) => ({ default: m.BookingEngine })));
const Calendar = lazy(() => import("./calendar/Calendar").then((m) => ({ default: m.Calendar })));
const Dashboard = lazy(() => import("./dashboard/Dashboard").then((m) => ({ default: m.Dashboard })));
const Groups = lazy(() => import("./groups").then((m) => ({ default: m.Groups })));
const Marketing = lazy(() => import("./marketing/Marketing").then((m) => ({ default: m.Marketing })));
const Onboarding = lazy(() => import("./onboarding/Onboarding").then((m) => ({ default: m.Onboarding })));
const Privacy = lazy(() => import("./legal/Privacy").then((m) => ({ default: m.Privacy })));
const Reviews = lazy(() => import("./reviews").then((m) => ({ default: m.Reviews })));
const Settings = lazy(() => import("./settings/Settings").then((m) => ({ default: m.Settings })));
const Terms = lazy(() => import("./legal/Terms").then((m) => ({ default: m.Terms })));

const RoutesList = () => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen w-full">
          <Spinner />
        </div>
      }
    >
      <Routes>
      {/** Public routes */}
      <Route path="/">
        <Route path="login" element={<Login />} />
        <Route path="auto-login" element={<AutoLogin />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="register" element={<Register />} />
        <Route path="register-marketing" element={<Register />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
      </Route>
      {/** Protected routes */}
      <Route element={<Main />}>
        <Route path="onboarding" element={<Onboarding />}>
          <Route path="onboarding/:session_id" element={<Onboarding />} />
        </Route>

        {/* Dashboard - Standard users only */}
        <Route
          path="dashboard"
          element={
            <PermissionGuard>
              <Dashboard />
            </PermissionGuard>
          }
        />

        {/* Marketing - Marketing users only */}
        <Route
          path="marketing"
          element={
            <PermissionGuard>
              <Marketing />
            </PermissionGuard>
          }
        />

        {/* Calendar - Standard users only */}
        <Route
          path="calendar"
          element={
            <PermissionGuard>
              <Calendar />
            </PermissionGuard>
          }
        />

{/* Settings - Standard users only */}
        <Route
          path="settings"
          element={
            <PermissionGuard>
              <Settings />
            </PermissionGuard>
          }
        />

        {/* AI Reasoning - Standard users only */}
        <Route
          path="ai-reasoning"
          element={
            <PermissionGuard>
              <AIReasoningPage />
            </PermissionGuard>
          }
        />

        {/* AI Reasoning - Standard users only */}
        <Route
          path="booking-engine"
          element={
            <PermissionGuard>
              <BookingEngine />
            </PermissionGuard>
          }
        />

        {/* Groups - Standard users only */}
        <Route
          path="groups"
          element={
            <PermissionGuard>
              <Groups />
            </PermissionGuard>
          }
        />

        {/* Reputation - Standard users only */}
        <Route
          path="reputation"
          element={
            <PermissionGuard>
              <Reviews />
            </PermissionGuard>
          }
        />

        <Route
          index
          element={
            // if logged in redirect to dashboard
            <Navigate to="/login" />
          }
        />
      </Route>
    </Routes>
    </Suspense>
  );
};
export default RoutesList;
